<template>
  <div class="content main-values">

    <div class="content-inner">

      <!-- Content -->
      <div class="content-block">
        <div class="content-block-image">
          <img src="/assets/static/values/peoples.svg" class="content-block-image" alt="peoples" width="374" height="241" loading="eager" fetchpriority="high">
        </div>

        <!-- Item -->
        <div class="content-block-item content-block-item--rocket">
          <section class="content-block-item-line">
            <div class="content-block-item-line-icon"></div>
            <p class="content-block-item-line-title"> Ми ненаситні </p>
          </section>
          <section class="content-block-item-content">
            <p class="content-block-item-content-text"> Для нас немає фінішу. Ми віримо у нашу команду та наш продукт і ми прагнемо продовжувати вчитися, розвиватися та вдосконалювати все, що робимо. Ми конкуруємо самі з собою тому, що не існує меж для самовдосконалення. </p>
          </section>
        </div>
      </div>

      <!-- Content -->
      <div class="content-block">

        <!-- Item -->
        <div class="content-block-item content-block-item--face">
          <section class="content-block-item-line">
            <div class="content-block-item-line-icon"></div>
            <p class="content-block-item-line-title"> Ми турбуємося про людей </p>
          </section>
          <section class="content-block-item-content">
            <p class="content-block-item-content-text"> У нас є відданість нашій команді та клієнтам, що є справжнім, беззаперечним та очевидним. </p>
          </section>
        </div>

        <!-- Item -->
        <div class="content-block-item content-block-item--light">
          <section class="content-block-item-line">
            <div class="content-block-item-line-icon"></div>
            <p class="content-block-item-line-title"> Ми ініціативні </p>
          </section>
          <section class="content-block-item-content">
            <p class="content-block-item-content-text"> Для нас немає обмежень, ми готові долати будь-які перешкоди для того щоб доставити Вам усе необхідне. </p>
          </section>
        </div>

        <!-- Item -->
        <div class="content-block-item content-block-item--hearth">
          <section class="content-block-item-line">
            <div class="content-block-item-line-icon"></div>
            <p class="content-block-item-line-title"> Ми щирі </p>
          </section>
          <section class="content-block-item-content">
            <p class="content-block-item-content-text"> Ми вважаємо, що чесність та справедливість повинна характеризувати спосіб взаємодії з нашою командою та спосіб представлення нашого товару на ринку. </p>
          </section>
        </div>

        <router-link class="content-vacancies-link" :to="localizedRoute('/vacancies')" exact>
          {{ $t('Continue to vacancies') }}
        </router-link>

      </div>
    </div>

  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;

  display: flex;
  justify-content: center;

  &-inner {
    width: 1154px;
    margin-top: 30px;
    padding: 0 20px;

    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: 1023px) {
      width: 100%;
      flex-direction: column;
      align-items: center;
    }
  }

  &-block {
    width: calc(100% / 2 - 15px);
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 1023px) {
      width: 100%;
    }

    &-image {
      width: 100%;
      padding: 20px 0;

      display: flex;
      justify-content: center;
      align-items: center;

      & img {
        width: 374px;
        height: 241px;
        float: left;

        @media only screen and (max-width: 415px) {
          width: 100%;
          height: auto;

          padding: 0;
        }
      }
    }

    &-item {
      width: 100%;

      & + & {
        margin-top: 20px;
      }

      &--rocket {
        & .content-block-item-line-icon {
          background-image: url('../../../../assets/static/values/icon-1.svg');
          background-size: 18px 22px;
        }

        @media only screen and (max-width: 1023px) {
          margin-bottom: 20px;
        }
      }

      &--face {
        & .content-block-item-line-icon {
          background-image: url('../../../../assets/static/values/icon-2.svg');
          background-size: 20px;
        }
      }

      &--light {
        & .content-block-item-line-icon {
          background-image: url('../../../../assets/static/values/icon-3.svg');
          background-size: 14px 20px;
        }
      }

      &--hearth {
        & .content-block-item-line-icon {
          background-image: url('../../../../assets/static/values/icon-4.svg');
          background-size: 22px 20px;
        }
      }

      &-line {
        display: flex;
        align-items: center;

        &-icon {
          width: 36px;
          height: 36px;

          background-color: #f5f5f5;
          background-position: center;
          background-repeat: no-repeat;

          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
        }

        &-title {
          margin: 0;
          padding-left: 10px;

          color: #333;
          font-size: 16px;
          font-weight: 600;
        }
      }

      &-content {
        padding: 20px;

        background: #f5f5f5;
        border-top-right-radius: 15px;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;

        &-text {
          margin: 0;

          font-size: 16px;
          color: #333;
        }
      }
    }
  }

  &-vacancies-link {
    display: flex;
    justify-content: center;
    margin-top: 25px;
    font-size: 17px;
    font-weight: bold;
    color: #11bb2e;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
